import { defineNuxtPlugin, useRuntimeConfig } from "#app";
import { StreamChatAdapter } from "./provider/stream.js";
export default defineNuxtPlugin((_) => {
  const config = useRuntimeConfig();
  const chatService = new StreamChatAdapter(config.public.streamApiKey);
  return {
    provide: {
      chat: chatService
    }
  };
});
